import {BadgePositionType, BannerContentType} from '../../../types';

type GetBannerOptionsReturnType = {
    badge: string;
    position: BadgePositionType;
    height: number;
    link: string;
};

/**
 * Getter for banner badge and its position
 */
export const getBannerBadgeOptions = (
    bannerData: BannerContentType | null,
): GetBannerOptionsReturnType | null => {
    if (
        !bannerData?.badge ||
        !bannerData?.badgePosition ||
        !bannerData?.badgeHeight ||
        !bannerData.badgeLink
    )
        return null;

    return {
        badge: bannerData.badge,
        height: bannerData.badgeHeight,
        link: bannerData.badgeLink,
        position: bannerData.badgePosition,
    };
};
